import PropTypes from "prop-types";
import React from "react";
import { TextField as OutlinedInput } from "@mui/material";

import CustomTooltip from "../Others/tooltip";

import { HelpBorderless } from "../../Assets/Icons";

const TextField = React.forwardRef(
  ({ className = "", label, description, errorMessage, helperText, tooltipContent, ...props }, ref) => {
    return (
      <div className={`text-field ${className}`}>
        {!!label && (
          <label>
            {label}
            {!!tooltipContent && (
              <CustomTooltip title={tooltipContent} placement="right">
                <button className="helper-tooltip" type="button">
                  <HelpBorderless />
                </button>
              </CustomTooltip>
            )}
          </label>
        )}
        {!!description && <span className="description">{description}</span>}
        <div className="input-icon-wrapper">
          <OutlinedInput fullWidth variant="outlined" {...props} inputRef={ref} />
        </div>
        {!!errorMessage && <span className="error-message">{errorMessage}</span>}
        {!!helperText && <span className="helper-text">{helperText}</span>}
      </div>
    );
  }
);

TextField.prototype = {
  className: PropTypes.string,
  label: PropTypes.string,
};

export default TextField;
